import Marquee from "react-fast-marquee";

export const BrandMarquee = ({ dark = false }) => (
  <div className={`overflow-hidden py-6 ${dark ? "bg-crate-black border-y border-white/10" : "bg-crate-yellow"}`} data-testid="brand-marquee">
    <Marquee speed={60} gradient={false}>
      {Array.from({ length: 8 }).map((_, i) => (
        <span key={i} className="mx-8 flex items-center gap-8">
          <span className={`font-heading font-black text-3xl md:text-5xl uppercase tracking-tight ${dark ? "text-stroke" : "text-crate-black"}`}>
            Move Smarter
          </span>
          <span className={`h-3 w-3 rounded-full ${dark ? "bg-crate-yellow" : "bg-crate-black"}`} />
          <span className={`font-heading font-black text-3xl md:text-5xl uppercase tracking-tight ${dark ? "text-crate-yellow" : "text-crate-black"}`}>
            Pack by Color
          </span>
          <span className={`h-3 w-3 rounded-full ${dark ? "bg-crate-yellow" : "bg-crate-black"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);
